import gql from 'graphql-tag';

export default gql`
  mutation adminEditSiteContacts($input: AdminEditSiteContactsInput!) {
    adminEditSiteContacts(input: $input) {
      id
    }
  }
`;
